import dayjs from "dayjs";

import type { DatesRange } from "@/types/entity";

export function isDateInRange(date: string, range: DatesRange) {
  const unix = dayjs(date).unix();
  return unix >= dayjs(range.from).unix() && unix <= dayjs(range.to).unix();
}

export function filterDateByRange(range: DatesRange) {
  return ({ date }: { date: string }) => {
    const unix = dayjs(date, "YYYY-MM").unix();
    return unix >= dayjs(range.from).unix() && unix <= dayjs(range.to).unix();
  };
}
